import moment from 'moment';
import {
  ETAT_ENREGISTRE,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';

export default function genererCritereRechercheOrdreTravailAffichage() {
  const dateIn7Days = new Date();
  dateIn7Days.setDate(new Date().getDate() + 7);
  const dateDebut = moment(dateIn7Days).startOf('week').toDate();
  const dateFin = moment(dateIn7Days).endOf('week').toDate();
  return {
    auto: null,
    periode: [dateDebut, dateFin],
    otEtat: [ETAT_ENREGISTRE],
    afficheur: [],
    agencesId: [],
  };
}
